(function () {
  function openDrawer() {
    var drawer = document.getElementById('Search-Drawer');
    if (!drawer) return;
    document.body.classList.add('open-cc', 'overflow-hidden');
    drawer.classList.add('active');
    drawer.removeAttribute('inert');
    setTimeout(function () {
      var input = drawer.querySelector('input[type="search"]');
      if (input) input.focus({ preventScroll: true });
    }, 100);
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('search:open');
    } else {
      document.dispatchEvent(new CustomEvent('search:open'));
    }
    document.querySelectorAll('.hp-search-trigger').forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.hp-search-trigger');
    if (!trigger) return;
    e.preventDefault();
    openDrawer();
  });

  document.addEventListener('panel:close', function () {
    document.querySelectorAll('.hp-search-trigger').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function (e) {
    var closeEl = e.target.closest && (e.target.closest('.side-panel-close') || e.target.closest('.click-capture'));
    if (!closeEl) return;
    document.querySelectorAll('.hp-search-trigger').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  });
})();
